import { createSelector } from "reselect";

export const proxiesSelector = createSelector(
    state => state.proxyManager.entries,
    state => state
);

export const selectedProxiesSelector = createSelector(
    state => state.proxyManager.entries.selectedProxies,
    state => state
);

export const attachExistedTagDialogSelector = createSelector(
    state => state.proxyManager.entries.attachExistedTagDialog,
    state => state
);

export const attachNewTagDialogSelector = createSelector(
    state => state.proxyManager.entries.attachNewTagDialog,
    state => state
);

export const detachTagDialogSelector = createSelector(
    state => state.proxyManager.entries.detachTagDialog,
    state => state
);

export const createProxyDialogSelector = createSelector(
    state => state.proxyManager.entries.createProxyDialog,
    state => state
);

export const importProxiesDialogSelector = createSelector(
    state => state.proxyManager.entries.importProxiesDialog,
    state => state
);
